export type Currency = 'USD';

export const formatCurrency = (currency: Currency, amount: number): string => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  });
  return formatter.format(amount);
};
